import { markRaw } from 'vue';
import { z } from 'zod';

import type { FieldsConfig, FormConfig, FormFieldConfig } from '../types';

import { allowedComponents } from '../types';

type ExtractSchemaShape<T extends FieldsConfig> = {
  [K in keyof T]: NonNullable<T[K]>['schema'];
};

export const defineFormConfig = <T extends FieldsConfig>(
  config: T,
  submitButtonText: string | null = null,
): FormConfig<ExtractSchemaShape<T>> & { fields: T } => {
  const schemaShape = <ExtractSchemaShape<T>>Object.fromEntries(Object.entries(config).map(([key, fieldConfig]) => [key, fieldConfig.schema]));

  const schema = markRaw(z.object(schemaShape));

  return { fields: config, schema, submitButtonText };
};

export const defineField = <T extends z.ZodTypeAny, F extends keyof typeof allowedComponents>(config: {
  initialValue: unknown;
  type: F;
  options: (typeof allowedComponents)[F]['options'];
  schema: T;
  hint?: string;
  wrapperClass?: string;
}): FormFieldConfig<T> => {
  return {
    initialValue: config.initialValue,
    schema: config.schema,
    hint: config.hint,
    wrapperClass: config.wrapperClass,
    component: allowedComponents[config.type].component,
    props: {
      ...config.options,
    },
  };
};
